import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { memo } from 'react';
import { FeatureGroup, GeoJSON } from 'react-leaflet';
import HeatMapCellDetails from './HeatMapCellDetails';
const HeatMapLayer = ({ cells }) => (_jsx(_Fragment, { children: cells.map((cell, i) => (_jsxs(FeatureGroup, { children: [_jsx(HeatMapCellDetails, { qualifiedAddresses: cell.properties.qualified_addresses, weeksSinceKnocked: cell.properties.avg_weeks_since_last_knocked, pinsScore: cell.properties.avg_qualified_area_quartile }), _jsx(GeoJSON, { style: cell.style, data: cell })] }, `${cell.type}-${i}`))) }));
HeatMapLayer.propTypes = {
    cells: PropTypes.array,
};
export default memo(HeatMapLayer);
